import React, { useEffect, useState } from 'react';
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, IconButton, MenuItem, Select, SelectChangeEvent, TextareaAutosize, TextField, Tooltip, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { createConfig, getConfigForTable, setCreateConfigStatus, setUpdateConfigStatus, updateConfig } from '../../redux/slices/config';
import SnackbarNotification from '../snackbar/snackbarNotification';
import { STATUS } from '../../utils/status';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { AddButton } from '../button/button';
import { useStyles } from '../../assets/styles/configStyle';
import AddIcon from '@mui/icons-material/Add'
import CloudUploadIcon from '@mui/icons-material/FileUpload';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import MicIcon from "@mui/icons-material/Mic";
import { createUploadFile, resetUploadFileState, setUploadFileStatus } from '../../redux/slices/uploadFile';
import { getReview } from '../../redux/slices/reviewerSlice';
import { ConfigIds } from './config';
import AddOptionsDialog from './dialogBoxForPaste';
import RichTextEditor from '../project/textEditor';
import { setSelectedStageId } from '../../redux/slices/reviewerSlice/index';
import { constants } from '../../utils/constants';
import { getCookie } from '../login/cookies';
import { getDownloadTemplate, getDownloadTemplateStatusReset } from '../../redux/slices/vendorList';
import OptionsDrawer from './OptionsDrawer';
import ExcelUploadDrawer from './ExcelUploadDrawer';
import ScoringConfigSection from './ScoringConfigSection';

interface ListTypeContentProps {
  chipLabel: string;
  chipId: string;
  keys: string[] | null;
  listFields: string[];
  taskCategory: string;
  configIds: ConfigIds[];
  configStatus: any;
  selectedStage?: string;
  selectedCategory?: string
}

const ListTypeContent: React.FC<ListTypeContentProps> = ({
  chipLabel,
  chipId,
  keys,
  listFields,
  taskCategory,
  configIds,
  configStatus,
  selectedStage,
  selectedCategory
}) => {
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const classes = useStyles();
  const createStatus = useSelector((state: RootState) => state.config.createStatus);
  const updateStatus = useSelector((state: RootState) => state.config.updateStatus);
  const listTypeData = useSelector((state: RootState) => state.config.currentConfig);
  const [correctAnswerIndex, setCorrectAnswerIndex] = useState<string | string[]>("");
  const [difficultyLevel, setDifficultyLevel] = useState<string>("");
  const [points, setPoints] = useState<number | ''>('');
  const navigate = useNavigate();
  const path = window.location.href.includes('test')
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<'success' | 'error' | 'info' | 'warning'>('success');
  const [selectedOption, setSelectedOption] = useState<'TASK' | 'REVIEW'>('TASK');
  const [formValues, setFormValues] = useState({ heading: '', long_description: '' });
  const [formValuesIdentifier, setFormValuesIdentifier] = useState({ identifier: '' });
  const [localListFields, setLocalListFields] = useState<string[]>(listFields.length > 0 ? listFields : ['']);
  const getConfig = useSelector((state: RootState) => state.config.currentConfig);
  const config_id = getConfig.id;
  const [order, setOrder] = useState('');
  // const [fileNames, setFileNames] = useState<string[]>([]);
  const [localIsChecked, setLocalIsChecked] = useState<boolean>(false);
  const [partialMarkingChecked, setPartialMarkingChecked] = useState<boolean>(false);
  const [configSticky, setConfigSticky] = useState<boolean>(false);
  const [enableOtherOption, setEnableOtherOption] = useState<boolean>(false);
  const [startConfig, setStartConfig] = useState<boolean>(false);
  const [endConfig, setEndConfig] = useState<boolean>(false);
  const isCheckbox = chipLabel === 'checkbox' || chipLabel === 'multi_select';
  const [selectedValue, setSelectedValue] = useState<{ [key: number]: string }>({});
  const [selectedValueNextConfig, setSelectedValueNextConfig] = useState<{ [key: number]: string }>({});
  // const [weightages, setWeightages] = useState<{ [key: string]: string }>({});
  const [fieldValues, setFieldValues] = useState<{ [key: string]: string }>({});
  const createConfigMessage = useSelector((state: RootState) => state.config.createConfigMessage)
  const updateConfigMessage = useSelector((state: RootState) => state.config.updateConfigMessage)
  const getReviewStages = useSelector((state: RootState) => state.reviewStage.reviewer);
  const getReviewStatus = useSelector((state: RootState) => state.reviewStage.getReviewStatus);
  const uploadFileData = useSelector((state: RootState) => state.uploadFile.data);
  const uploadFileDataStatus = useSelector((state: RootState) => state.uploadFile.uploadFileStatus);
  const uploadFileDataMessage = useSelector((state: RootState) => state.uploadFile.uploadFileMessage)
  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const addPath = window.location.href.includes('addtest')
  const [selectedImage, setSelectedImage] = useState<any>('');
  const [showAudio, setShowAudio] = useState<any>(undefined);
  const [showVideo, setShowVideo] = useState<any>(undefined);
  const [nextConfigId, setNextConfigId] = useState<ConfigIds>();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [showAll, setShowAll] = useState(false);
  const [outputValues, setOutputValues] = useState<string[]>([""]);
  const [autoOpen, setAutoOpen] = useState<boolean>(false);
  const [enableScoring, setEnableScoring] = useState<boolean>(false);
  const [scoringMode, setScoringMode] = useState<string>('AUTO');
  const [scoringTitle, setScoringTitle] = useState<string>('');

  
  const [excelFile, setExcelFile] = useState<File | null>(null);
  const [excelUrl, setExcelUrl] = useState<string>("");
  const [categoryData, setCategoryData] = useState<any[]>([]);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState<string>("");
  const [selectedSubCategoryIndex, setSelectedSubCategoryIndex] = useState<string>("");
  const [excelUploadStatus, setExcelUploadStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  
  const [singleSelectExcelFile, setSingleSelectExcelFile] = useState<File | null>(null);
  const [singleSelectExcelUploadStatus, setSingleSelectExcelUploadStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [singleSelectExportStatus, setSingleSelectExportStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [uploadedFileUrl, setUploadedFileUrl] = useState<string>('');
  const [uploadedFileName, setUploadedFileName] = useState<string>('');
  
  
  const [optionsDrawerOpen, setOptionsDrawerOpen] = useState(false);
  const [excelDrawerOpen, setExcelDrawerOpen] = useState(false);
  const [defaultOptionProjectLimit, setDefaultOptionProjectLimit] = useState<string>('');
  const [defaultOptionUserLimit, setDefaultOptionUserLimit] = useState<string>('');

  
  const [projectLimits, setProjectLimits] = useState<string[]>(['']);
  const [userLimits, setUserLimits] = useState<string[]>(['']);
  
  
  const [optionIds, setOptionIds] = useState<(string | undefined)[]>([undefined]);

  const handleToggleShowMore = () => {
    setShowAll((prev) => !prev);
  };

  let { configRowId } = useParams()

  useEffect(() => {
    // Reset status when component mounts or config changes
    dispatch(setCreateConfigStatus(STATUS.NOT_STARTED));
    dispatch(setUpdateConfigStatus(STATUS.NOT_STARTED));
    
    if (configRowId) {
      dispatch(getConfigForTable({ project_id: id, id: configRowId }))
    }
  }, [configRowId, id])

  useEffect(() => {
    if (getConfig) {
      const { value, type, correct_answer_index, long_description } = getConfig;
      if (chipLabel === 'adjectives_list' && value && value.value && Array.isArray(value.value)) {
        setSelectedValue(value.value.map((val: { tag: any; }) => val.tag))
      }
      if (chipLabel === 'radio' && value && value.value && Array.isArray(value.value)) {
        setSelectedValueNextConfig(value.value.map((val: { next_config_id: any; }) => val.next_config_id))
      }

      // Handle multi_level_dropdown - check if value.value contains category objects
      if (chipLabel === 'multi_level_dropdown' && value && value.value && Array.isArray(value.value) &&
        value.value.length > 0 && value.value[0].category) {
        setLocalListFields(['']);
        if (value.label) {
          setFormValues({ heading: value.label, long_description: long_description });
        } else {
          setFormValues({ heading: '', long_description: long_description });
        }
      } else if (Array.isArray(value)) {
        setLocalListFields(value);
        setFormValues({ heading: '', long_description: '' });
      } else if (value && value.value && Array.isArray(value.value)) {
        if (value.value.length > 0 && typeof value.value[0] === 'object' && 'value' in value.value[0]) {
          const extractedValues = value.value.map((item: any) => item.value);
          setLocalListFields(extractedValues);
          if (value.label) {
            setFormValues({ heading: value.label, long_description: long_description });
          } else {
            setFormValues({ heading: '', long_description: long_description });
          }
        } else {
          setLocalListFields(value.value);
          if (value.label) {
            setFormValues({ heading: value.label, long_description: long_description });
          } else {
            setFormValues({ heading: '', long_description: long_description });
          }
        }
      } else {
        setLocalListFields(['']);
        setFormValues({ heading: '', long_description: getConfig.long_description });
      }

      if (getConfig.identifier !== undefined) {
        setFormValuesIdentifier({ identifier: getConfig.identifier });
      }
      setSelectedOption(type);
      setOrder(getConfig.order);
      setLocalIsChecked(getConfig.required)
      setPartialMarkingChecked(getConfig.partial_marking)
      setConfigSticky(getConfig.is_sticky)
      setEnableOtherOption(getConfig.enable_other_option || false)
      setDefaultOptionProjectLimit(getConfig.default_option_project_limit?.toString() ?? '')
      setDefaultOptionUserLimit(getConfig.default_option_user_limit?.toString() ?? '')
      setStartConfig(getConfig.is_starting_config)
      setEndConfig(getConfig.is_end_config)
      if (correct_answer_index) {
        const parsedCorrectAnswers = correct_answer_index
          .split(',')
          .map((idx: string) => parseInt(idx.trim(), 10) - 1);
        setCorrectAnswerIndex(parsedCorrectAnswers);
      }
      else {
        setCorrectAnswerIndex([]);
      }
      setPoints(getConfig.points)
      setDifficultyLevel(getConfig.difficulty_level)
      setFieldValues(getConfig?.value)
      setUploadedFiles(getConfig?.multimedia_links || [])
      setNextConfigId(configIds.find(item => item.id === getConfig.next_config_id))
      setSelectedStageId(getConfig.stage_id);
      setAutoOpen(getConfig.auto_open);

      // Load uploaded file for single_select/multi_select - check both value.uploaded_file and root uploaded_file
      if ((chipLabel === 'single_select' || chipLabel === 'multi_select') && (value?.uploaded_file || getConfig?.uploaded_file)) {
        const uploadedFileUrl = value?.uploaded_file || getConfig?.uploaded_file;
        setUploadedFileUrl(uploadedFileUrl);
        setSingleSelectExcelUploadStatus('success');
        // Use original_filename if available, otherwise extract from URL
        const fileName = value?.original_filename || getConfig?.original_filename || uploadedFileUrl.split('/').pop() || 'uploaded_file.xlsx';
        setUploadedFileName(fileName);
      }

      // Load project_limits, user_limits, and option IDs for single_select/multi_select
      if ((chipLabel === 'single_select' || chipLabel === 'multi_select') && value && value.value && Array.isArray(value.value)) {
        const loadedProjectLimits = value.value.map((item: any) => item.project_limit?.toString() || '');
        const loadedUserLimits = value.value.map((item: any) => item.user_limit?.toString() || '');
        const loadedOptionIds = value.value.map((item: any) => item.id || undefined);
        setProjectLimits(loadedProjectLimits.length > 0 ? loadedProjectLimits : ['']);
        setUserLimits(loadedUserLimits.length > 0 ? loadedUserLimits : ['']);
        setOptionIds(loadedOptionIds.length > 0 ? loadedOptionIds : [undefined]);
      }
      setEnableScoring(getConfig.enable_scoring || false);
      setScoringMode(getConfig.scoring_mode || 'AUTO');
      setScoringTitle(getConfig.scoring_title || '');

      // Load Excel URL and refetch category data when editing
      if (getConfig?.multimedia_links && Array.isArray(getConfig.multimedia_links) && getConfig.multimedia_links.length > 0) {
        const excelLink = getConfig.multimedia_links.find((link: string) => link.includes('.xlsx') || link.includes('.xls'));
        if (excelLink) {
          setExcelUrl(excelLink);
          setExcelUploadStatus('success');

          // For multi_level_dropdown, load categories from value.value
          if (chipLabel === 'multi_level_dropdown' && value && value.value && Array.isArray(value.value)) {
            setCategoryData(value.value);
          }
        }
      }

      const selectedOption = getConfig?.value?.value?.map((item: any) => item.output_value) || [];
      if (selectedOption) {
        setOutputValues(selectedOption);
      }

      // setWeightages(getConfig?.value?.value.map((item: { weightage: number; }) => item.weightage));
      //  setSelectedValue(tags);
    }
  }, [getConfig, configIds]);

  const handleSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const downloadTemplateStatus = useSelector((state: RootState) => state.vendorList.getDownloadTemplateStatus);
    const downloadTemplateLink = useSelector((state: RootState) => state.vendorList.template);
  
    useEffect(() => {
      if (
        downloadTemplateStatus === "SUCESS" &&
        downloadTemplateLink?.data?.download_url
      ) {
        const link = document.createElement("a");
        link.href = downloadTemplateLink.data.download_url;
        link.setAttribute("download", "template.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        handleSnackbar('Template downloaded successfully', 'success');
        dispatch(getDownloadTemplateStatusReset(STATUS.NOT_STARTED));
      }
    }, [downloadTemplateStatus, downloadTemplateLink]);

  const handleDownloadTemplate = () => {
    const payload = {
      template_name: 'Category_Subcategory_Template',
      project_id: id,
      file_type: 'xlsx'
    };
    dispatch(getDownloadTemplate(payload));
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSubmit = () => {
    if (path) {
      const missingFields = [];
      const duplicates = localListFields.filter((item, index) => localListFields.indexOf(item) !== index);

      if (!formValues.heading) missingFields.push("Question");
      if (correctAnswerIndex.length === 0) missingFields.push("Correct Answer");
      if (points === undefined) missingFields.push("Points");
      if (!difficultyLevel) missingFields.push("Difficulty Level");
      if (!order) missingFields.push("Order");
      if (localListFields.includes('')) missingFields.push("At least one option");
      if (duplicates.length > 0) { missingFields.push('Answer choice cannot have same options'); }

      if (missingFields.length > 0) {
        handleSnackbar(`Please fill required fields: ${missingFields.join(", ")}`, "error");
        return;
      }
    }
    else {
      const missingFields = [];
      const isSelectableConfig = chipLabel === 'single_select' || chipLabel === 'multi_select';
      const shouldValidateManualOptions = !(isSelectableConfig && enableOtherOption);
      if (!formValuesIdentifier.identifier) missingFields.push("Identifier");

      // Skip output value and options validation for multi_level_dropdown
      if (chipLabel !== 'multi_level_dropdown') {
        // For single_select/multi_select with Excel upload, skip manual validation
        if ((chipLabel === 'single_select' || chipLabel === 'multi_select') && uploadedFileUrl) {
          // Excel file is uploaded, no need to validate manual fields
        } else {
          if (shouldValidateManualOptions && outputValues.every(value => value.trim() === "") && !path) {
            missingFields.push('Missing Output Value');
          }
          if (shouldValidateManualOptions && localListFields.includes('')) {
            missingFields.push(
              isSelectableConfig
                ? "At least one option (not mandatory when allow others option tick)"
                : "At least one option"
            );
          }
        }
      } else {
        // Validate Excel upload for multi_level_dropdown
        if (!excelUrl || excelUploadStatus !== 'success') {
          missingFields.push("Excel File Upload");
        }
      }

      if (!formValues?.heading) missingFields.push("Title");
      if (!fieldValues?.description && chipLabel !== 'single_select' && chipLabel !== 'multi_select') missingFields.push("Description");
      if (enableScoring && scoringMode === 'MANUAL' && !scoringTitle.trim()) missingFields.push('Scoring Title');

      if (missingFields.length > 0) {
        handleSnackbar(`Please fill required fields: ${missingFields.join(", ")}`, "error");
        return;
      }
    }

    if (!path && selectedOption === "REVIEW" && !selectedStage) {
      handleSnackbar("Stage is required for review", "error");
      return;
    }

    const payload = {
      ...(config_id && { id: config_id }),
      project_id: id,
      task_category_id: taskCategory,
      config_id: chipId,
      name: chipLabel,
      long_description: formValues?.long_description,
      next_config_id: nextConfigId === undefined ? '' : nextConfigId?.id,
      value: {
        label: formValues?.heading || fieldValues?.title || fieldValues?.label,
        title: formValues?.heading || fieldValues?.title || fieldValues?.label,
        description: fieldValues?.description,
        // For all configs, use nested 'value' property
        value: chipLabel === 'multi_level_dropdown' && categoryData.length > 0
          ? categoryData  // Put categoryData directly in value array
          : localListFields?.filter(el => el.length > 0).map((field, index) => {
            if (field) {
              const shouldIncludeOptionLimits = !path && ['single_select', 'multi_select'].includes(chipLabel);

              return (
                {
                  index: index + 1,
                  value: field,
                  ...(selectedValue[index] && { tag: selectedValue[index] }),
                  ...(selectedValueNextConfig[index] && { next_config_id: selectedValueNextConfig[index] }),
                  ...(outputValues && { output_value: outputValues[index] }),
                  ...(shouldIncludeOptionLimits && {
                    project_limit: getOptionLimitValue(projectLimits, index),
                    user_limit: getOptionLimitValue(userLimits, index),
                  }),
                  // ...(partialMarkingChecked && weightages[index] && { weightage: weightages[index] })
                }
              )
            } else {
              return undefined;
            }
          }).filter(val => val !== undefined),
        // Add uploaded_file URL in value object for single_select/multi_select with Excel
        ...((chipLabel === 'single_select' || chipLabel === 'multi_select') && uploadedFileUrl && { uploaded_file: uploadedFileUrl })
      },
      ...(path ? { type: 'TEST' } : selectedCategory ? { type: selectedCategory } : {}),
      // identifier: formValuesIdentifier.identifier,
      ...(formValuesIdentifier.identifier?.length > 0 && { identifier: formValuesIdentifier.identifier }),
      ...(order && Number(order) !== 0 && { order: Number(order) }),
      required: path ? true : localIsChecked,
      ...(path && {
        correct_answer_index: chipLabel !== "radio" && chipLabel !== "single_select"
          ? (Array.isArray(correctAnswerIndex)
            ? correctAnswerIndex.map(index => (parseInt(index) + 1).toString()).join(",")
            : (parseInt(correctAnswerIndex) + 1).toString())
          : (parseInt(correctAnswerIndex[0]) + 1).toString()
      }),
      ...(path && { partial_marking: partialMarkingChecked }),
      is_sticky: configSticky,
      ...((chipLabel === 'single_select' || chipLabel === 'multi_select') && { enable_other_option: enableOtherOption }),
      ...((chipLabel === 'single_select' || chipLabel === 'multi_select') && enableOtherOption && {
        default_option_project_limit: defaultOptionProjectLimit.trim() !== '' ? parseInt(defaultOptionProjectLimit, 10) : 0,
        default_option_user_limit: defaultOptionUserLimit.trim() !== '' ? parseInt(defaultOptionUserLimit, 10) : 0,
      }),
      ...(path && points && { points: points }),
      ...(path && { difficulty_level: difficultyLevel }),
      ...(chipLabel === 'multi_level_dropdown'
        ? { multimedia_links: excelUrl ? [excelUrl] : [] }  // For multi_level_dropdown, only keep latest Excel URL
        : (chipLabel === 'single_select' || chipLabel === 'multi_select') && uploadedFileUrl
          ? { uploaded_file: uploadedFileUrl }  // For single_select/multi_select with Excel, include uploaded_file
          : { multimedia_links: excelUrl ? [...uploadedFiles, excelUrl] : uploadedFiles }), // For others, keep all files
      stage_id: typeof selectedStage === "string" && !isNaN(Number(selectedStage))
        ? Number(selectedStage)
        : selectedStage,
      is_starting_config: startConfig,
      is_end_config: endConfig,
      auto_open: chipLabel === 'radio' && (Array.isArray(selectedValueNextConfig) ? selectedValueNextConfig.some(v => !!v) : Object.values(selectedValueNextConfig).some(v => !!v)) ? false : autoOpen,
      enable_scoring: enableScoring,
      ...(enableScoring && { scoring_mode: scoringMode }),
      scoring_title: (enableScoring && scoringMode === 'MANUAL' && scoringTitle.trim()) ? scoringTitle.trim() : null,
    };

    const newUpdateValues = Object.keys(payload).reduce((acc, key) => {
      const fetchedValue = listTypeData[key];
      const newValue = payload[key];
      if (
        key in listTypeData &&
        newValue !== fetchedValue &&
        (fetchedValue !== '')
      ) {
        acc[key] = newValue;
      }

      return acc;
    }, {} as Record<string, string | boolean | string[] | undefined>);

    if ((chipLabel === 'single_select' || chipLabel === 'multi_select') && uploadedFileUrl && singleSelectExcelFile) {
      const formData = new FormData();

      Object.keys(payload).forEach(key => {
        if (key === 'multimedia_links') {
          return;
        }

        if (key === 'value') {
          formData.append(key, JSON.stringify(payload[key]));
        } else if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
          formData.append(key, payload[key].toString());
        }
      });

      formData.append('file', singleSelectExcelFile);

      const apiEndpoint = `${constants.API_BASE_URL}project/company/config/`;
      const method = config_id ? 'PATCH' : 'POST';
      if (config_id) {
        dispatch(setUpdateConfigStatus(STATUS.PENDING));
      } else {
        dispatch(setCreateConfigStatus(STATUS.PENDING));
      }

      fetch(apiEndpoint, {
        method: method,
        headers: {
          'Authorization': `Bearer ${getCookie('token')}`
        },
        body: formData
      })
      .then(response => {
        console.log('Response status:', response.status, response.ok);
        return response.json();
      })
      .then(result => {
        console.log('Config submission result:', result);
        if (result.data?.id || result.id || result.error === null) {
          console.log('Success - setting status to SUCESS');
          handleSnackbar(config_id ? 'Config Updated Successfully' : 'Config Added Successfully', 'success');
          setTimeout(() => {
            path ? navigate(`/project/${id}?tab=test`) : navigate(`/project/${id}?tab=config`);
          }, 1000);
        } else {
          console.log('Failed - no success indicator in result, setting status to FAILED');
          handleSnackbar(result.message || 'Error occurred', 'error');
        }
      })
      .catch(error => {
        console.error('Error submitting config:', error);
        handleSnackbar('Error occurred while submitting', 'error');
      });
    } else {
      // For other types and single_select with manual options, use Redux actions (JSON)
      if (config_id) {
        dispatch(updateConfig({
          id: config_id,
          ...newUpdateValues,
          // Always send enable_other_option and its dependent limits regardless of diff
          ...((chipLabel === 'single_select' || chipLabel === 'multi_select') && { enable_other_option: enableOtherOption }),
          ...((chipLabel === 'single_select' || chipLabel === 'multi_select') && enableOtherOption && {
            default_option_project_limit: defaultOptionProjectLimit.trim() !== '' ? parseInt(defaultOptionProjectLimit, 10) : 0,
            default_option_user_limit: defaultOptionUserLimit.trim() !== '' ? parseInt(defaultOptionUserLimit, 10) : 0,
          }),
        }));
      } else {
        dispatch(createConfig(payload));
      }
    }
  };

  const handleRemoveField = (index: number) => {
    if (index === 0) {
      return;
    }

    const updatedFields = [...localListFields];
    updatedFields.splice(index, 1);
    setLocalListFields(updatedFields);

    const updatedOutputs = [...outputValues];
    updatedOutputs.splice(index, 1);
    setOutputValues(updatedOutputs);

    if (chipLabel === 'single_select' || chipLabel === 'multi_select') {
      const updatedProjectLimits = [...projectLimits];
      updatedProjectLimits.splice(index, 1);
      setProjectLimits(updatedProjectLimits);

      const updatedUserLimits = [...userLimits];
      updatedUserLimits.splice(index, 1);
      setUserLimits(updatedUserLimits);
      
      const updatedOptionIds = [...optionIds];
      updatedOptionIds.splice(index, 1);
      setOptionIds(updatedOptionIds);
    }

    handleClearSelection(index);
  };

  const handleFieldChange = (index: any, value: string) => {
    setFieldValues((prevValues) => ({
      ...prevValues,
      [index]: value
    }));
    if (index === 'label') {
      setFormValues({ ...formValues, heading: value })
    }
    const updatedFields = [...localListFields];
    updatedFields[index] = value;
    setLocalListFields(updatedFields);
  };

  const handleOrderChange = (e: any) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === '' || regex.test(e.target.value)) {
      setOrder(e.target.value);
    }
  };

  useEffect(() => {
    const handleCreateStatus = () => {
      if (createStatus === STATUS.SUCESS) {
        handleSnackbar(path ? 'Question Added Successfully' : 'Config Added Successfully', 'success');
        // dispatch(resetUploadFileState());
        // setUploadedFiles([]);
        setTimeout(() => {
          path ? navigate(`/project/${id}?tab=test`) : navigate(`/project/${id}`)
        }, 1000);
      }
      if (createStatus === STATUS.FAILED) {
        handleSnackbar(createConfigMessage, 'error');
      }
    }
    handleCreateStatus();
    return () => {
      if (createStatus === STATUS.SUCESS || createStatus === STATUS.FAILED) {
        dispatch(setCreateConfigStatus(STATUS.NOT_STARTED));
      }
    };
  }, [createStatus]);

  useEffect(() => {
    const handleUpdateStatus = () => {
      if (updateStatus === STATUS.SUCESS) {
        handleSnackbar(path ? 'Question Updated Successfully' : 'Config Updated Successfully', 'success');
        // dispatch(resetUploadFileState());
        // setUploadedFiles([]);
        setTimeout(() => {
          path ? navigate(`/project/${id}/tab=test`) : navigate(`/project/${id}`)
        }, 1000);
      }

      if (updateStatus === STATUS.FAILED) {
        // handleSnackbar('Error Occurred, Please try again!', 'error');
        handleSnackbar(updateConfigMessage, 'error');
      }
    };

    handleUpdateStatus();
    return () => {
      if (updateStatus === STATUS.SUCESS || updateStatus === STATUS.FAILED) {
        dispatch(setUpdateConfigStatus(STATUS.NOT_STARTED));
      }
    };
  }, [updateStatus, navigate, dispatch]);

  useEffect(() => {
    const handleFileUpdateStatus = () => {
      if (uploadFileDataStatus === STATUS.SUCESS) {
        handleSnackbar('File Uploaded Successfully', 'success');
      }

      if (uploadFileDataStatus === STATUS.FAILED) {
        handleSnackbar(uploadFileDataMessage, 'error');
      }
    };

    handleFileUpdateStatus();
    return () => {
      if (uploadFileDataStatus === STATUS.SUCESS || uploadFileDataStatus === STATUS.FAILED) {
        dispatch(setUploadFileStatus(STATUS.NOT_STARTED));
      }
    };
  }, [uploadFileDataStatus, navigate, dispatch]);

  const handlePasteOptionChange = () => {
    setIsDialogOpen(true)
  };

  const handlePointsChange = (e: any) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === '' || regex.test(e.target.value)) {
      setPoints(e.target.value);
    }
  };

  const handleDifficultyChange = (event: SelectChangeEvent<string>) => {
    setDifficultyLevel(event.target.value as string);
  };

  const handleCorrectAnswerChange = (event: SelectChangeEvent<string | string[]>) => {
    const value = event.target.value;
    if (Array.isArray(value)) {
      setCorrectAnswerIndex(value);
    } else {
      setCorrectAnswerIndex([value]);
    }
  };

  const handleTextFieldChange = (index: number, value: string) => {
    handleFieldChange(index, value);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setLocalIsChecked(checked);
  };

  const handlePartialMarkingCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setPartialMarkingChecked(checked);
  };

  const handleStickyCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setConfigSticky(checked);
  }
  
  const handleEnableOtherOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setEnableOtherOption(checked);
  };
  
  const handleStartConfigCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setStartConfig(checked);
  };

  const handleAutoOpenCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setAutoOpen(checked);
  };

  const handleEndConfigCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setEndConfig(checked);
  };

  // const handleWeightageChange = (index: string, event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   const newWeightages = { ...weightages, [index]: event.target.value };
  //   setWeightages(newWeightages);
  // };

  //something missing here removed in merge conflict -> pending Vishakha 
  const handleChangeViolative = (index: number, value: string) => {
    setSelectedValue((prev) => ({
      ...prev,
      [index]: value,
    }));
  }
  const handleRadioDropDownChange = (index: number, value: string) => {
    setSelectedValueNextConfig((prev) => ({
      ...prev,
      [index]: value,
    }));
  }
  const handleDropDownChange = (index: number, value: string) => {
    // handleTagChange(index, value);
    setNextConfigId(configIds.find(item => item.identifier === value));
  }

  const getOptionLimitValue = (limits: string[], index: number) => {
    const limitValue = limits[index]?.trim();

    if (!limitValue) {
      return 0;
    }

    const parsedLimit = parseInt(limitValue, 10);
    return Number.isNaN(parsedLimit) ? 0 : parsedLimit;
  };

  const handleClearSelection = (index: number) => {
    setSelectedValueNextConfig((prev) => {
      const updatedConfig = { ...prev };
      delete updatedConfig[index];
      return updatedConfig;
    });
  };

  const handleClearSelectionNextConfig = () => {
    setNextConfigId(undefined);
  };

  useEffect(() => {
    setUploadedFiles([]);
    dispatch(resetUploadFileState());
  }, [addPath, createStatus])

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files: File[] = Array.from(event.target.files || []);

    const validTypes = ['image/jpeg', 'image/png', 'audio/mp3', 'audio/wav', 'video/mp4'];
    const invalidFiles = files.filter((file) => !validTypes.includes(file.type));

    if (invalidFiles.length > 0) {
      handleSnackbar('Invalid file type. Please select an image(jpeg, png), audio(mp3, wav), or video(mp4).', 'error');
      return;
    }

    if (uploadedFiles?.length === 2) {
      const confirmReplace = window.confirm('Uploading new files will replace the existing ones. Are you sure?');
      if (!confirmReplace) return;
      // setFileNames([]);
      setUploadedFiles([]);
    }
    const newFiles = uploadedFiles?.length === 1 ? [...uploadedFiles, ...files.map((file) => file.name)] : files.map((file) => file.name);
    if (newFiles.length > 2) {
      handleSnackbar('You can upload a maximum of 2 files.', 'warning');
      return;
    }

    // setFileNames(uploadedFiles);
    for (const file of files) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        await dispatch(createUploadFile(formData));
      } catch (error) {
        handleSnackbar('Error uploading file.', 'error');
      }
    }
  };

  useEffect(() => {
    dispatch(getReview({ project_id: id || '' }))
  }, [dispatch, id]);

  useEffect(() => {
    if (uploadFileData && !uploadedFiles.includes(uploadFileData)) {
      setUploadedFiles((prevFiles: string[]) => {
        const updatedFiles = prevFiles.length === 0
          ? [uploadFileData]
          : [...prevFiles, uploadFileData].filter(Boolean);
        return updatedFiles;
      });
    }
  }, [uploadFileData]);

  const handleDeleteFile = (indexToDelete: number) => {
    setUploadedFiles((prev) => prev.filter((_, index) => index !== indexToDelete));
  };

  const handleExcelFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (!validTypes.includes(file.type)) {
      handleSnackbar('Invalid file type. Please upload an Excel file (.xls or .xlsx).', 'error');
      event.target.value = '';
      return;
    }

    setExcelFile(file);
    setExcelUploadStatus('loading');

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${constants.API_BASE_URL}project/configs/category-tree/from-excel/`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getCookie('token')}`
        },
        body: formData
      });

      const result = await response.json();

      if (result.error === false && result.status === 200) {
        setCategoryData(result.data);
        setExcelUrl(result.excel_url);
        setExcelUploadStatus('success');
        handleSnackbar('Excel uploaded successfully!', 'success');
      } else {
        setExcelUploadStatus('error');
        handleSnackbar('Failed to upload Excel file.', 'error');
      }
    } catch (error) {
      console.error('Error uploading Excel:', error);
      setExcelUploadStatus('error');
      handleSnackbar('Error uploading Excel file.', 'error');
    } finally {
      event.target.value = '';
    }
  };

  const handleSingleSelectExcelUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    if (!validTypes.includes(file.type)) {
      handleSnackbar('Invalid file type. Please upload an Excel file (.xls or .xlsx).', 'error');
      event.target.value = '';
      return;
    }

    setSingleSelectExcelFile(file);
    setSingleSelectExcelUploadStatus('loading');

    const formData = new FormData();
    formData.append('file', file);
    
    if (configRowId) {
      formData.append('config_id', configRowId);
      formData.append('handle_deletions', 'true');
    }

    const uploadEndpoint = configRowId 
      ? `project/company/config_options/bulk-upload/`
      : 'upload/company/';

    try {
      const response = await fetch(`${constants.API_BASE_URL}${uploadEndpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getCookie('token')}`
        },
        body: formData
      });

      const result = await response.json();

      // Handle both response formats
      const fileUrl = result.file_url || result.data?.file_url;
      // Check for success: response.ok, file_url exists, explicit success flag, or success message
      const hasSuccessMessage = result.message && (
        result.message.toLowerCase().includes('success') || 
        result.message.toLowerCase().includes('uploaded')
      );
      const success = response.ok && (fileUrl || result.success || result.error === null || hasSuccessMessage);

      if (success) {
        setSingleSelectExcelUploadStatus('success');
        if (fileUrl) {
          setUploadedFileUrl(fileUrl);
        }
        // Keep the file reference for preview even without URL (bulk-upload case)
        // The uploadedFileUrl from initial load will remain, ensuring preview stays visible
        setUploadedFileName(file.name);
        const message = configRowId 
          ? result.message || `Excel "${file.name}" uploaded and options updated successfully!`
          : `Excel "${file.name}" uploaded successfully!`;
        handleSnackbar(message, 'success');
      } else {
        setSingleSelectExcelUploadStatus('error');
        handleSnackbar(result.message || 'Failed to upload Excel file.', 'error');
        setSingleSelectExcelFile(null);
      }
    } catch (error) {
      console.error('Error uploading Excel:', error);
      setSingleSelectExcelUploadStatus('error');
      handleSnackbar('Error uploading Excel file.', 'error');
      setSingleSelectExcelFile(null);
    } finally {
      event.target.value = '';
    }
  };

  const handleSingleSelectExcelExport = async () => {
    if (!config_id) {
      handleSnackbar('Please save the config first before exporting.', 'error');
      return;
    }

    setSingleSelectExportStatus('loading');

    try {
      const response = await fetch(`${constants.API_BASE_URL}project/company/config_options/export/?config_id=${config_id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getCookie('token')}`
        }
      });

      const result = await response.json();

      if (result.url) {
        const link = document.createElement('a');
        link.href = result.url;
        link.setAttribute('download', 'config_options.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setSingleSelectExportStatus('success');
        handleSnackbar(`Export successful! Total records: ${result.total_records}`, 'success');
        setTimeout(() => setSingleSelectExportStatus('idle'), 2000);
      } else {
        setSingleSelectExportStatus('error');
        handleSnackbar('Failed to export options.', 'error');
        setTimeout(() => setSingleSelectExportStatus('idle'), 2000);
      }
    } catch (error) {
      console.error('Error exporting Excel:', error);
      setSingleSelectExportStatus('error');
      handleSnackbar('Error exporting Excel file.', 'error');
      setTimeout(() => setSingleSelectExportStatus('idle'), 2000);
    }
  };

  const handleDownloadSingleSelectTemplate = () => {
    const payload = {
      template_name: 'Config_Bulk_Options_Upload_Template',
      project_id: id,
      file_type: 'xlsx'
    };
    dispatch(getDownloadTemplate(payload));
  }

  const fetchConfigOptions = async (showSnackbar: boolean = true) => {
    if (!config_id) {
      setOptionsDrawerOpen(true);
      return;
    }

    try {
      const response = await fetch(`${constants.API_BASE_URL}project/common/config_options/?config_id=${config_id}&value=`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${getCookie('token')}`
        }
      });

      const result = await response.json();

      // Check if result is an array (direct response) or has success/data structure
      const data = Array.isArray(result) ? result : (result.success && result.data && Array.isArray(result.data) ? result.data : []);

      if (data.length > 0) {
        const fetchedValues = data.map((item: any) => item.value);
        const fetchedOutputValues = data.map((item: any) => item.output_value || '');
        const fetchedProjectLimits = data.map((item: any) => item.project_limit?.toString() || '');
        const fetchedUserLimits = data.map((item: any) => item.user_limit?.toString() || '');
        const fetchedIds = data.map((item: any) => item.id);
        
        setLocalListFields(fetchedValues);
        setOutputValues(fetchedOutputValues);
        setProjectLimits(fetchedProjectLimits);
        setUserLimits(fetchedUserLimits);
        setOptionIds(fetchedIds);
        
        if (showSnackbar) {
          handleSnackbar(`Loaded ${data.length} options successfully`, 'success');
        }
      } else {
        // No options found, set defaults
        setLocalListFields(['']);
        setOutputValues(['']);
        setProjectLimits(['']);
        setUserLimits(['']);
        setOptionIds([undefined]);
        if (showSnackbar) {
          handleSnackbar('No options found', 'info');
        }
      }
    } catch (error) {
      console.error('Error fetching config options:', error);
      if (showSnackbar) {
        handleSnackbar('Error loading options', 'error');
      }
    } finally {
      setOptionsDrawerOpen(true);
    }
  };;

  const handleOptionsDone = async () => {
    await fetchConfigOptions(false);
  };

  const handleCategoryChange = (event: SelectChangeEvent<string>) => {
    setSelectedCategoryIndex(event.target.value);
    setSelectedSubCategoryIndex(""); // Reset subcategory when category changes
  };

  const handleSubCategoryChange = (event: SelectChangeEvent<string>) => {
    setSelectedSubCategoryIndex(event.target.value);
  };

  const handleCloseDialog = () => setIsDialogOpen(false);

  const handleAddCustomField = () => {
    // Limit to 20 options for single_select/multi_select
    if ((chipLabel === 'single_select' || chipLabel === 'multi_select') && localListFields.length >= 20) {
      handleSnackbar('Maximum 20 options allowed', 'warning');
      return;
    }
    setLocalListFields([...localListFields, ""]);
    setOutputValues([...outputValues, ""]);
    if (chipLabel === 'single_select' || chipLabel === 'multi_select') {
      setProjectLimits([...projectLimits, ""]);
      setUserLimits([...userLimits, ""]);
      setOptionIds([...optionIds, undefined]);
    }
    handleCloseDialog();
  };

  // const handleBulkPaste = (options: string[]) => {
  //   if (path) {
  //     setLocalListFields([...localListFields, ...options]);
  //   } else {
  //     setLocalListFields([...options]);
  //   }
  // };

  const handleBulkPaste = (options: string[]) => {
    const newFields: string[] = [];
    const newOutputValues: string[] = [];
    const newUserLimits: string[] = [];
    const newProjectLimits: string[] = [];

    options.forEach((line) => {
      const [userVal, outputVal, userLimit, projectLimit] = line.split('<::>').map(part => part?.trim());
      if (userVal) {
        console.log(userVal, outputVal, userLimit, projectLimit);
        newFields.push(userVal);
        newOutputValues.push(outputVal !== undefined ? outputVal : "");
        newUserLimits.push(userLimit !== undefined ? userLimit : "");
        newProjectLimits.push(projectLimit !== undefined ? projectLimit : "");
      }
    });

    if (path) {
      setLocalListFields([...newFields, ...localListFields]);
    } else {
      const updatedFields = [...newFields, ...localListFields].filter(val => val.trim() !== "");
      const updatedOutputs = [...newOutputValues, ...outputValues];
      const updatedUserLimits = [...newUserLimits, ...userLimits];
      const updatedProjectLimits = [...newProjectLimits, ...projectLimits];
      
      // Limit to 20 options for single_select/multi_select
      if ((chipLabel === 'single_select' || chipLabel === 'multi_select') && updatedFields.length > 20) {
        handleSnackbar(`Maximum 20 options allowed. Only first 20 options will be added.`, 'warning');
        setLocalListFields(updatedFields.slice(0, 20));
        setOutputValues(updatedOutputs.slice(0, 20));
        setUserLimits(updatedUserLimits.slice(0, 20));
        setProjectLimits(updatedProjectLimits.slice(0, 20));
        const newOptionIds = new Array(20).fill(undefined);
        setOptionIds(newOptionIds);
      } else {
        setLocalListFields(updatedFields);
        setOutputValues(updatedOutputs);
        // Set limits for new options
        if (chipLabel === 'single_select' || chipLabel === 'multi_select') {
          setUserLimits(updatedUserLimits);
          setProjectLimits(updatedProjectLimits);
          const newOptionIds = new Array(updatedFields.length).fill(undefined);
          setOptionIds(newOptionIds);
        }
      }
    }
  };

  const renderField = (field: string, index: number) => (
    <div className={classes.fieldContainer}>
      <div className={classes.fieldContent}>
        {['radio', 'single_select', 'discard_list'].includes(chipLabel) && (
          <RadioButtonUncheckedIcon fontSize="medium" className={classes.dragIcon} />
        )}
        {['checkbox', 'multi_select', 'adjectives_list'].includes(chipLabel) && (
          <CheckBoxOutlineBlankIcon fontSize="medium" className={classes.dragIcon} />
        )}
        {path ?
          <TextareaAutosize
            placeholder={`Option ${index + 1}`}
            value={field}
            onChange={(e) => handleTextFieldChange(index, e.target.value)}
            className={classes.textField}
            style={{ marginLeft: '10px', marginTop: '10px', height: "50px", padding: "5px", width: "227px", border: "1px solid" }}
          /> :
          <>
            <TextField
              size="small"
              placeholder={`Option ${index + 1}`}
              margin="normal"
              value={field}
              onChange={(e) => handleTextFieldChange(index, e.target.value)}
              className={classes.textField}
            />
            <TextField
              size="small"
              placeholder={`Output Value`}
              margin="normal"
              value={outputValues?.[index] ?? ""}
              onChange={(e) => {
                const updatedOutputs = [...outputValues || []];
                updatedOutputs[index] = e.target?.value;
                setOutputValues(updatedOutputs);
              }}
              className={classes.textField}
            />
          </>
        }
        {index !== 0 && (
          <div className={classes.removeButton} onClick={() => handleRemoveField(index)}>
            <ClearIcon fontSize="small" className={classes.removeIcon} />
          </div>
        )}
        {chipLabel === 'adjectives_list' &&
          <FormControl>
            <Select variant="standard" sx={{ m: 1, minWidth: 100, marginBottom: "15px" }}
              labelId="demo-simple-select-label"
              id={`demo-simple-select-${index}`}
              label="Tag"
              value={selectedValue[index] || (selectedValue[index]) || ""}
              onChange={(e) => handleChangeViolative(index, e.target.value)}
              displayEmpty
            >
              <MenuItem value="" disabled>Select tag</MenuItem>
              <MenuItem value={"violative"}>Violative</MenuItem>
              <MenuItem value={"non-violative"}>Non-Violative</MenuItem>
            </Select>
          </FormControl>
        }
        {!path && chipLabel === 'radio' &&
          <div>
            <FormControl sx={{ m: 1, minWidth: 100, marginBottom: "15px", display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Select
                variant="standard"
                labelId={`demo-simple-select-label-${index}`}
                id={`demo-simple-select-${index}`}
                label="Tag"
                value={selectedValueNextConfig[index] || ""}
                disabled={!!nextConfigId}
                onChange={(e) => handleRadioDropDownChange(index, e.target.value)}
                displayEmpty
                renderValue={(selected) => {
                  const selectedItem = configIds.find((item) => item.id === selected);
                  const label = selectedItem?.identifier || "No Name";
                  return label.length > 20 ? `${label.slice(0, 20)}...` : label;
                }}
              >
                <MenuItem value="" disabled>
                  Select Next Config
                </MenuItem>
                {configIds.map((dataItem) => (
                  <MenuItem key={dataItem.id} value={dataItem.id}>
                    {dataItem.identifier ? dataItem.identifier : "No Name"}
                  </MenuItem>
                ))}
              </Select>
              {selectedValueNextConfig[index] && (
                <Button
                  onClick={() => handleClearSelection(index)}
                  size="small"
                  sx={{ ml: 1, minWidth: "auto" }}
                >
                  Clear
                </Button>
              )}
            </FormControl>
          </div>
        }
      </div>
    </div>
  )

  const handleLongDesc = (newContentHTML: { json: string; html: string }) => {
    setFormValues((prevState: any) => ({
      ...prevState,
      long_description: newContentHTML.html,
    }));
  };

  return (
    <>
      {/* <div style={{ display: 'flex' }}>
        <Typography sx={{ fontFamily: 'Montserrat', fontSize: 20, fontWeight: 600, lineHeight: '24px', color: '#10383D', marginTop: 2, marginBottom: 2, textTransform: 'capitalize', }}>
          {chipLabel.replace(/_/g, ' ')}
        </Typography>
      </div> */}

      {path && (
        <div style={{ display: 'flex', marginBottom: '20px', gap: 170, marginTop: '20px' }}>
          <div>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>
              Upload Media:<br />
            </Typography>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> You can upload image, video, audio only </Typography>
          </div>
          <Box sx={{ marginTop: '15px' }}>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              startIcon={<CloudUploadIcon />}
            >
              Upload files
              <input
                type="file"
                accept="image/*,audio/*,video/*"
                onChange={handleFileChange}
                multiple
                hidden
              />
            </Button>
            {uploadFileDataStatus === STATUS.PENDING && <Typography variant="body2" mt={2}>Uploading File...</Typography>}
            {uploadedFiles && uploadedFiles.length > 0 && (
              <Box mt={1} display="flex" flexWrap="wrap" gap={2}>
                {uploadedFiles.map((name, index) => {
                  const isImage = /\.(jpg|jpeg|png)$/i.test(name);
                  const isAudio = /\.(mp3|wav)$/i.test(name);
                  const isVideo = /\.(mp4)$/i.test(name);

                  return (
                    <Box key={index} position="relative" width={120} height={120}>
                      {isImage && (
                        <>
                          <img
                            src={name}
                            alt={`uploaded-${index}`}
                            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 8, cursor: "pointer" }}
                            onClick={() => setSelectedImage(name)}
                          />
                        </>
                      )}

                      {isAudio && (
                        <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%" border="1px solid #ccc" borderRadius={8} p={2}>
                          <IconButton onClick={() => setShowAudio(name)}>
                            <MicIcon fontSize="large" />
                          </IconButton>
                        </Box>
                      )}

                      {isVideo && (
                        <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%" border="1px solid #ccc" borderRadius={8}>
                          <IconButton onClick={() => setShowVideo(name)}>
                            <PlayArrowIcon fontSize="large" />
                          </IconButton>
                        </Box>
                      )}

                      <IconButton
                        onClick={() => handleDeleteFile(index)}
                        sx={{
                          position: "absolute",
                          top: 2,
                          right: 2,
                          background: "rgba(0,0,0,0.5)",
                          color: "white",
                          "&:hover": { background: "rgba(0,0,0,0.7)" }
                        }}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  );
                })}

                <Dialog open={Boolean(selectedImage)} onClose={() => setSelectedImage(null)}>
                  <DialogContent>
                    <img src={selectedImage} alt="Preview" style={{ width: "100%", height: "auto", borderRadius: 8 }} />
                  </DialogContent>
                </Dialog>
                <Dialog open={Boolean(showVideo)} onClose={() => setShowVideo(null)}>
                  <DialogContent>
                    <video width="100%" height="100%" style={{ borderRadius: 8 }} controls>
                      <source src={showVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </DialogContent>
                </Dialog>
                <Dialog open={Boolean(showAudio)} onClose={() => setShowAudio(null)}>
                  <DialogContent>
                    <figure>
                      <figcaption>Listen Uploaded Audio:</figcaption>
                      <audio controls src={showAudio}></audio>
                    </figure>
                  </DialogContent>
                </Dialog>
              </Box>
            )}
          </Box>

        </div>
      )}

      {!path &&
        <div style={{ display: 'flex', marginBottom: '20px', gap: 150 }}>
          <div>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>
              Enter Unique Identifier:<br />
            </Typography>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> This Name will identify unique configs </Typography>
          </div>

          <div>
            <TextField
              placeholder="Enter Identifier"
              name="formValuesIdentifier"
              value={formValuesIdentifier.identifier}
              onChange={(e) => {
                const value = e.target.value;
                const sanitizedValue = value.replace(/[^a-zA-Z0-9_]/g, '');
                setFormValuesIdentifier({ identifier: sanitizedValue });
              }}
              sx={{ marginTop: '10px' }}
              size="small"
            />
          </div>
        </div>
      }
      {/* {path && */}
      {!path && !keys &&
        <div style={{ display: 'flex', marginBottom: '20px' }}>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>{path ? 'Enter Question' : 'Enter Heading'}:<br />
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> Enter the {path ? 'question' : 'heading'} that will be displayed to the expert.</Typography>
          </Typography>
          <TextareaAutosize
            placeholder={path ? 'Enter Question' : 'Enter heading'}
            name="formValues"
            value={formValues.heading}
            onChange={(e) => setFormValues({ heading: e.target.value, long_description: getConfig.long_description })}
            style={{ marginLeft: '55px', marginTop: '10px', height: "50px", padding: "5px", width: "227px", border: "1px solid" }}

          />
        </div >}
      {/* } */}

      {path &&
        <div style={{ display: 'flex', marginBottom: '20px' }}>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>{path ? 'Enter Question' : 'Enter Heading'}:<br />
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> Enter the {path ? 'question' : 'heading'} that will be displayed to the expert.</Typography>
          </Typography>
          <TextareaAutosize
            placeholder={path ? 'Enter Question' : 'Enter heading'}
            name="formValues"
            value={formValues.heading}
            onChange={(e) => setFormValues({ heading: e.target.value, long_description: formValues.long_description })}
            style={{ marginLeft: '55px', marginTop: '10px', height: "50px", padding: "5px", width: "227px", border: "1px solid" }}

          />
        </div >}

      {path &&
        <div style={{ display: 'flex', marginBottom: '20px' }}>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>Difficulty Level :<br />
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> Select the difficulty level of this question. </Typography>
          </Typography>
          <FormControl sx={{ marginLeft: '30px' }}>
            <Select value={difficultyLevel} displayEmpty onChange={handleDifficultyChange} size='small' sx={{ marginLeft: '47%', width: '227px' }}>
              <MenuItem value="" disabled>Select Difficulty Label</MenuItem>
              <MenuItem value="EASY">Easy</MenuItem>
              <MenuItem value="MEDIUM">Medium</MenuItem>
              <MenuItem value="HARD">Hard</MenuItem>
            </Select>
          </FormControl>
        </div>
      }

      {path &&
        <div style={{ display: 'flex', marginBottom: '20px', gap: 120 }}>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>Score Value :<br />
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> Specify the points assigned to this question </Typography>
          </Typography>
          <TextField
            value={points}
            size='small'
            sx={{ width: '227px' }}
            onChange={handlePointsChange}
            placeholder="Score Value"
          />
        </div>
      }

      {!path && keys &&
        <>
          <div style={{ display: 'flex', marginBottom: '10px', gap: 130 }}>
            <div>
              <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>
                Enter Value
              </Typography>
              <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> This heading will be visible on expert side </Typography>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
              {keys?.map((key: any, index) => {
                return (
                  <div style={{ marginRight: '20px' }} key={index}>
                    <TextField
                      size='small'
                      placeholder={key}
                      variant="outlined"
                      fullWidth
                      value={(fieldValues !== undefined) ? (key === 'title' ? fieldValues['label'] : fieldValues[key]) : ''}
                      onChange={(e) => handleFieldChange(key === 'title' ? 'label' : key, e.target.value)}
                      style={{ marginBottom: '10px' }}
                    />
                  </div>
                )
              })}
            </div>
          </div>
        </>
      }

      <div style={{ display: 'flex', marginBottom: '20px', gap: 160 }}>

        <div>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>
            Enter Long Description:<br />
          </Typography>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> This would be visible on Expert Side. </Typography>
        </div>

        <div>
          <RichTextEditor
            key={getConfig?.id || 'editor_placeholder_key'}
            onChange={handleLongDesc}
            initialContent={getConfig?.long_description || ''}
          />
        </div>
      </div>

      {/* Excel Upload Section - only show for multi_level_dropdown */}
      {!path && chipLabel === 'multi_level_dropdown' && (
        <>
          <div style={{ display: 'flex', marginBottom: '20px', gap: 130 }}>
            <div>
              <Typography
                sx={{
                  fontFamily: 'Montserrat',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '24px',
                  color: '#10383D',
                  marginTop: '5px',
                }}
              >
                Upload Excel File:
              </Typography>

              <Typography
                sx={{
                  fontFamily: 'Montserrat',
                  fontSize: '12px',
                  fontWeight: 400,
                  lineHeight: '24px',
                  color: '#10383D',
                }}
              >
                Upload category-subcategory Excel (.xls or .xlsx) - Required
              </Typography>
            </div>

            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '15px',
                marginTop: '10px',
                alignItems: 'flex-start',
              }}
            >
              <Button
                variant="outlined"
                size="small"
                startIcon={<CloudDownloadIcon />}
                onClick={handleDownloadTemplate}
              >
                Download Template
              </Button>

              {/* Excel Upload Button */}
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Button
                  component="label"
                  variant="contained"
                  startIcon={<CloudUploadIcon />}
                  disabled={excelUploadStatus === 'loading'}
                  size="small"
                >
                  {excelUploadStatus === 'loading' ? 'Uploading...' : 'Upload Excel'}
                  <input
                    type="file"
                    accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    onChange={handleExcelFileChange}
                    hidden
                  />
                </Button>

                {excelUploadStatus === 'loading' && (
                  <Typography sx={{ fontSize: '10px', marginTop: '5px' }}>
                    Uploading...
                  </Typography>
                )}

                {excelFile && excelUploadStatus === 'success' && (
                  <Typography
                    sx={{ fontSize: '10px', marginTop: '5px', color: 'green' }}
                  >
                    ✓ {excelFile.name}
                  </Typography>
                )}

                {!excelFile && excelUploadStatus === 'success' && excelUrl && (
                  <Typography
                    sx={{
                      fontSize: '10px',
                      marginTop: '5px',
                      color: 'primary.main',
                    }}
                  >
                    ℹ Previous Excel loaded
                  </Typography>
                )}
              </Box>

              {/* Download Uploaded Excel */}
              {excelUploadStatus === 'success' && excelUrl && (
                <Tooltip title="Download Uploaded Excel">
                  <IconButton
                    onClick={() => window.open(excelUrl, '_blank')}
                    sx={{
                      backgroundColor: '#1976d2',
                      color: 'white',
                      '&:hover': { backgroundColor: '#1565c0' },
                      height: '40px',
                      width: '40px',
                    }}
                    size="small"
                  >
                    <CloudDownloadIcon />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        </>
      )}

      {path && <div style={{ display: 'flex', marginBottom: '20px', gap: path ? 130 : 140 }}>

        <div>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>
            Display Order:<br />
          </Typography>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}> Set the position of this {path ? 'question' : 'config'} in the list. </Typography>
        </div>

        <div>
          <TextField
            placeholder="Enter Order"
            name="order"
            value={order}
            // type='number'
            onChange={handleOrderChange}
            sx={{ marginTop: '10px' }}
            size="small"
          />
        </div>

      </div>}

      {/* Excel Upload/Export Section for single_select/multi_select */}
      {!path && (chipLabel === 'single_select' || chipLabel === 'multi_select') && (
        <div style={{ display: 'flex', marginBottom: '20px', gap: 215 }}>
          <div>
            <Typography
              sx={{
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontWeight: 600,
                lineHeight: '24px',
                color: '#10383D',
                marginTop: '5px',
              }}
            >
              Enter Options:
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Montserrat',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '24px',
                color: '#10383D',
              }}
            >
              Choose how to add options
            </Typography>
          </div>

          <div
            style={{
              display: 'flex',
              gap: '12px',
              marginTop: '5px',
              alignItems: 'center',
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setExcelDrawerOpen(true)}
              sx={{
                textTransform: 'none',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontWeight: 500,
                padding: '8px 20px',
                borderRadius: '6px',
                borderColor: '#1976d2',
                color: '#1976d2',
                borderWidth: '1.5px',
                '&:hover': {
                  borderColor: '#1565c0',
                  backgroundColor: 'rgba(25, 118, 210, 0.04)',
                  borderWidth: '1.5px',
                },
              }}
            >
              Upload Excel
            </Button>

            <Button
              variant="contained"
              onClick={() => fetchConfigOptions()}
              sx={{
                textTransform: 'none',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontWeight: 500,
                padding: '8px 20px',
                borderRadius: '6px',
                backgroundColor: '#1976d2',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                  backgroundColor: '#1565c0',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                },
              }}
            >
              Enter Options Manually
            </Button>
          </div>
        </div>
      )}

      {/* Hide Enter Options field for multi_level_dropdown, single_select, and multi_select */}
      {chipLabel !== 'multi_level_dropdown' && chipLabel !== 'single_select' && chipLabel !== 'multi_select' && (
        <div style={{ display: 'flex', gap: path ? 120 : 175 }}>
          <Typography
            sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '15px', marginRight: '22px' }}
          >
            {!path ? 'Enter Options' : 'Answer Choice'} : <br />
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>{path ? ' Enter the possible answer options' : ' Enter the possible options'}</Typography>
          </Typography>
          <div >
            <Button onClick={handlePasteOptionChange} sx={{ color: 'black', textTransform: 'none', marginLeft: '20px', border: '1px solid black' }} startIcon={<AddIcon />}>Bulk Paste Options</Button>
            <div style={{ display: 'flex', position: 'relative', alignItems: "center", gap: "12px" }}>
              <Box >
                <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                  {Array.isArray(localListFields) &&
                    (showAll ? localListFields : localListFields.slice(0, 5)).map((field, index) => renderField(field, index))}
                </div>
              </Box>

              <Tooltip title="Click this button to add more options">
                <IconButton
                  style={{
                    position: 'absolute',
                    bottom: '20px',
                    right: '-10%',
                    backgroundColor: '#3D85C6',
                    color: '#fff',
                    padding: '7px',
                    borderRadius: '50%',
                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                    transition: 'transform 0.3s ease',
                  }}
                  onClick={handleAddCustomField}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  <AddIcon />
                </IconButton>
              </Tooltip>
            </div>
            {localListFields.length > 5 && (
              <Button
                onClick={handleToggleShowMore}
                sx={{
                  textTransform: 'none',
                  fontSize: '14px',
                  color: '#3D85C6',
                  marginTop: '2px',
                  alignSelf: 'flex-start'
                }}
              >
                {showAll ? 'Show Less' : 'See More'}
              </Button>
            )}
          </div>

        </div>
      )}

      {
        path &&
        <div>
          {localListFields && (
            <div style={{ display: 'flex', marginBottom: '20px' }}>
              <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '5px' }}>
                Correct Answer: <br />
                <Typography sx={{ fontFamily: 'Montserrat', fontSize: '12px', fontWeight: 400, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D' }}>
                  Select the correct answer from the provided options.
                </Typography>
              </Typography>
              <FormControl>
                <Select
                  multiple={isCheckbox}
                  value={Array.isArray(correctAnswerIndex) ? correctAnswerIndex : []}
                  onChange={handleCorrectAnswerChange}
                  size="small"
                  sx={{ marginLeft: '25%', width: '227px', marginTop: '10px' }}
                  renderValue={(selected) => {
                    if (Array.isArray(selected)) {
                      return selected.map((idx) => localListFields[parseInt(idx)]).join(', ');
                    } else {
                      return localListFields[parseInt(selected)];
                    }
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Correct Answer
                  </MenuItem>
                  {localListFields.map((option, idx) => (
                    <MenuItem key={idx} value={idx.toString()}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          )}
        </div>
      }
      {
        !path &&
        <div style={{ display: 'flex', gap: 133 }}>
          <div>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '15px' }}>
              Do you want to stick this config?
            </Typography>
          </div>
          <div>
            <Checkbox
              checked={configSticky}
              onChange={handleStickyCheckboxChange}
              color="primary"
              sx={{ marginTop: '5px' }}
            />
          </div>
        </div>
      }
      {
        !path && (chipLabel === 'single_select' || chipLabel === 'multi_select') &&
        <div style={{ display: 'flex', gap: 276 }}>
          <div>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '15px' }}>
              Allow Others
            </Typography>
          </div>
          <div>
            <Checkbox
              checked={enableOtherOption}
              onChange={handleEnableOtherOptionChange}
              color="primary"
              sx={{ marginTop: '5px' }}
            />
          </div>
        </div>
      }
      {
        !path && (chipLabel === 'single_select' || chipLabel === 'multi_select') && enableOtherOption &&
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', color: '#10383D', minWidth: '338px' }}>
              Default Project Limit
            </Typography>
            <TextField
              type="number"
              size="small"
              value={defaultOptionProjectLimit}
              onChange={(e) => {
                const val = e.target.value;
                if (val === '' || (Number(val) >= 0 && Number.isInteger(Number(val)))) {
                  setDefaultOptionProjectLimit(val);
                }
              }}
              inputProps={{ min: 0, step: 1 }}
              sx={{ width: '160px' }}
              placeholder="0"
            />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', color: '#10383D', minWidth: '338px' }}>
              Default Other User Limit
            </Typography>
            <TextField
              type="number"
              size="small"
              value={defaultOptionUserLimit}
              onChange={(e) => {
                const val = e.target.value;
                if (val === '' || (Number(val) >= 0 && Number.isInteger(Number(val)))) {
                  setDefaultOptionUserLimit(val);
                }
              }}
              inputProps={{ min: 0, step: 1 }}
              sx={{ width: '160px' }}
              placeholder="0"
            />
          </div>
        </div>
      }
      {
        path && (chipLabel === 'checkbox' || chipLabel === 'multi_select') &&
        <div style={{ display: 'flex' }}>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '15px' }}>
            Do you want to mark Partial Marking for this question?
          </Typography>
          <Checkbox
            checked={partialMarkingChecked}
            onChange={handlePartialMarkingCheckboxChange}
            color="primary"
            sx={{ marginTop: '5px' }}
          />
        </div>
      }
      {!path &&
        <div style={{ display: 'flex', gap: "234px" }}>
          <div>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '15px' }}>
              Is this start config?
            </Typography>
          </div>
          <div>
            <Checkbox
              checked={startConfig}
              onChange={handleStartConfigCheckboxChange}
              color="primary"
              sx={{ marginTop: '5px' }}
            />
          </div>
        </div>
      }

      <div style={{ display: "flex", gap: "286px" }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "24px",
            letterSpacing: "0px",
            textAlign: "left",
            color: "#10383D",
            marginTop: "15px",
          }}
        >
          Auto Open?
        </Typography>
        <Checkbox
          checked={autoOpen}
          onChange={handleAutoOpenCheckboxChange}
          color="primary"
          disabled={chipLabel === 'radio' && (Array.isArray(selectedValueNextConfig) ? selectedValueNextConfig.some(v => !!v) : Object.values(selectedValueNextConfig).some(v => !!v))}
          sx={{ marginTop: "5px" }}
        />
      </div>

      {!path &&
        <div style={{ display: 'flex', gap: 190 }}>
          <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginRight: '50px', marginTop: '15px' }}>
            Select Next Config
          </Typography>
          {configStatus === "loading" && <Typography>Loading...</Typography>}

          {configStatus === "success" && (
            <FormControl sx={{ m: 1, marginBottom: "15px", display: "flex", flexDirection: "row", alignItems: "center" }}>
              <Select
                size='small'
                disabled={Array.isArray(selectedValueNextConfig) ? selectedValueNextConfig.some(v => !!v) : Object.values(selectedValueNextConfig).some(v => !!v)}
                label="config"
                value={nextConfigId !== undefined ? nextConfigId.identifier : ''}
                onChange={(e) => handleDropDownChange(0, e.target.value)}
                displayEmpty
                sx={{ width: '220px' }}
              >
                <MenuItem value="" disabled>
                  Select Next Config
                </MenuItem>
                {configIds.map((dataItem) => (
                  <MenuItem key={dataItem.id} value={dataItem.identifier}>
                    {dataItem.identifier ? dataItem.identifier : "No Name"}
                  </MenuItem>
                ))}
              </Select>
              {nextConfigId && (
                <Button
                  onClick={handleClearSelectionNextConfig}
                  size="small"
                  sx={{ minWidth: "auto" }}
                >
                  Clear
                </Button>
              )}
            </FormControl>
          )}
          {configStatus === "error" && (
            <Typography sx={{ color: "red" }}>Error fetching configs. Please try again.</Typography>
          )}
        </div>
      }
      {/* <AddButton onClick={handleAddListField}>Add More</AddButton> */}
      <ScoringConfigSection
        enableScoring={enableScoring}
        scoringMode={scoringMode}
        scoringTitle={scoringTitle}
        onEnableScoringChange={setEnableScoring}
        onScoringModeChange={setScoringMode}
        onScoringTitleChange={setScoringTitle}
        gap={266}
      />
      {
        !path &&
        <div style={{ display: 'flex', gap: 130 }}>
          <div>
            <Typography sx={{ fontFamily: 'Montserrat', fontSize: '14px', fontWeight: 600, lineHeight: '24px', letterSpacing: '0px', textAlign: 'left', color: '#10383D', marginTop: '15px' }}>
              {path ? 'Check this box if answering this question should be mandatory' : 'Do you want to mark it required?'}
            </Typography>
          </div>
          <div>
            <Checkbox
              checked={localIsChecked}
              onChange={handleCheckboxChange}
              color="primary"
              sx={{ marginTop: '5px' }}
            />
          </div>
        </div>
      }
      <br />
      <AddButton
        disabled={config_id ? updateStatus == STATUS.PENDING : createStatus == STATUS.PENDING}
        startIcon={(config_id && updateStatus === STATUS.PENDING) || (createStatus === STATUS.PENDING) ? (<CircularProgress size={20} />) : null}
        onClick={handleSubmit}
      >
        {config_id ? "Update" : "Submit"}
      </AddButton>
      <SnackbarNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
      <AddOptionsDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        onBulkPaste={handleBulkPaste}
        chipLabel={chipLabel}
      />

      {/* Options Drawer for single_select */}
      <OptionsDrawer
        open={optionsDrawerOpen}
        onClose={() => setOptionsDrawerOpen(false)}
        chipLabel={chipLabel}
        localListFields={localListFields}
        outputValues={outputValues}
        path={path}
        showAll={showAll}
        onFieldChange={handleTextFieldChange}
        onOutputValueChange={(index, value) => {
          const updatedOutputs = [...outputValues || []];
          updatedOutputs[index] = value;
          setOutputValues(updatedOutputs);
        }}
        onRemoveField={handleRemoveField}
        onAddField={handleAddCustomField}
        onToggleShowMore={handleToggleShowMore}
        onBulkPaste={handlePasteOptionChange}
        projectLimits={projectLimits}
        userLimits={userLimits}
        onProjectLimitChange={(index, value) => {
          const updated = [...projectLimits];
          updated[index] = value;
          setProjectLimits(updated);
        }}
        onUserLimitChange={(index, value) => {
          const updated = [...userLimits];
          updated[index] = value;
          setUserLimits(updated);
        }}
        optionIds={optionIds}
        configId={config_id}
        onDone={handleOptionsDone}
      />

      {/* Excel Upload Drawer for single_select */}
      <ExcelUploadDrawer
        open={excelDrawerOpen}
        onClose={() => setExcelDrawerOpen(false)}
        uploadStatus={singleSelectExcelUploadStatus}
        exportStatus={singleSelectExportStatus}
        onDownloadTemplate={handleDownloadSingleSelectTemplate}
        onUploadExcel={handleSingleSelectExcelUpload}
        onExportExcel={handleSingleSelectExcelExport}
        configId={config_id}
        excelUploaded={uploadedFileUrl !== ''}
        uploadedFileName={uploadedFileName}
      />
    </>
  );
};

export default ListTypeContent;